export const transcriptPlayerKeys = {
  all: [{ module: 'transcriptPlayer' }] as const,
  details: () => [{ ...transcriptPlayerKeys.all[0], scope: 'detail' }] as const,
  detail: (jobId: string, transcript: string) => [{ ...transcriptPlayerKeys.details()[0], jobId, transcript }] as const,
  audio: (jobId: string, attempt: number) =>
    [{ ...transcriptPlayerKeys.all[0], scope: 'audio', jobId, attempt }] as const,
};
